import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Mascot.css';

function Mascot() {
  const [message, setMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  
  const showEncouragement = (msg) => {
    setMessage(msg);
    setShowMessage(true);
    setTimeout(() => setShowMessage(false), 3000);
  };
  
  useEffect(() => {
    window.showMascotMessage = showEncouragement;
  }, []);
  
  return (
    <div className="mascot-container" data-testid="mascot">
      <motion.div
        className="mascot"
        animate={{
          y: [0, -10, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        <div className="mascot-body">
          <div className="mascot-face">
            <div className="mascot-eye left"></div>
            <div className="mascot-eye right"></div>
            <div className="mascot-mouth"></div>
          </div>
        </div>
      </motion.div>
      
      <AnimatePresence>
        {showMessage && (
          <motion.div
            className="mascot-speech"
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            data-testid="mascot-message"
          >
            {message}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Mascot;
